export const useIsHome = () => {
  const route = useRoute()
  const { locale } = useI18n()

  const isHome = computed( // Toda ruta que vaya aqui, no mostrara el SearchInput antes de ir a la ruta
    () =>
      route.path === `/${locale.value}` ||
      route.path === `/${locale.value}/login` ||
      route.path === `/${locale.value}/user-zone/reservas`
  )
  
  return {
    isHome
  }
}

export const useBaseUrl = () => {
  const runtimeConfig = useRuntimeConfig()
  const event = useRequestEvent()
  const baseUrl = event ? runtimeConfig.public.API_SERVER_BASE_URL : runtimeConfig.public.API_CLIENT_BASE_URL
  return baseUrl
}